<!--
  @author:chen.hao
  @time:2018/12/14
  @disc: 广告位查看弹出层
 -->

<template>
  <el-dialog
    title="查看"
    :visible.sync="visible"
    width="500px"
    @close="$emit('update:show',false)">
    <el-form ref="form" label-width="100px">
      <el-form-item label="终端类型">{{info.deviceType}}</el-form-item>
      <el-form-item label="广告位名称">{{info.name}}</el-form-item>
      <el-form-item label="广告位标识符">{{info.code}}</el-form-item>
      <el-form-item label="广告位描述">{{info.statement||'无'}}</el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'infoViewDialog',
  props: ['show', 'info'],
  data () {
    return {
      visible: false
    }
  },
  watch: {
    show () {
      this.visible = this.show
    }
  }
}
</script>

<style scoped>
</style>
